import { AfterContentInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-parameter-item',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ce-parameter-item.component.html',
    styleUrl: './ce-parameter-item.component.scss',
    host: {
        '[class]': '_computedClass()',
    },
    encapsulation: ViewEncapsulation.None,
})
export class CeParameterItemComponent implements AfterContentInit {
    @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
    @Input() truncated = false;

    _computedClass() {
        const classes = ['CeParameterItem'];
        classes.push(`CeParameterItem--${this.orientation}`);
        classes.push(`CeParameterItem--${this.hasChildren ? 'hasChildren' : 'noChildren'}`);
        classes.push(`CeParameterItem--${this.truncated ? 'truncated' : 'notTruncated'}`);
        return classes.join(' ');
    }

    @ViewChild('secondary', { static: true }) secondaryElement!: ElementRef;
    hasChildren = false;

    ngAfterContentInit(): void {
        const nativeElement = this.secondaryElement.nativeElement;
        this.hasChildren = nativeElement.children.length > 0;
    }
}
